const { getBiRewardsGroupForCheckout } = require('services/api/beautyInsider/getBiRewardsGroup');
const { getPurchaseHistory } = require('services/api/beautyInsider');
const UtilActions = require('utils/redux/Actions');

function fetchProfileRewards() {
    return (dispatch) => {
        getBiRewardsGroupForCheckout().
            then(data => dispatch(UtilActions.merge('rewards', 'rewards', data)));
    };
}

function fetchRecentlyRedeemedRewards(userId, options) {
    return (dispatch) => {
        getPurchaseHistory(userId, options).
            then(data => dispatch(UtilActions.merge(
                'rewards', 'rewardsPurchasedGroups', data.purchasedGroups)));
    };
}

module.exports = {
    fetchProfileRewards,
    fetchRecentlyRedeemedRewards
};
